import { Loading } from "element-ui";
import axios from "axios";
import vue from "vue";
function guidFn() {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
axios.interceptors.request.use(
  function(config) {
    if (config.url !== "/security/web/auth/login") {
      config.headers["ms-token"] = sessionStorage.getItem("ms_token");
    }
    if (config.method == "get") {
      config.data = { ignore: true };
    }
    let str = "";
    let path = sessionStorage.getItem("path");
    let specialPath = sessionStorage.getItem("specialPath");
    let rpath = specialPath || path;
    //let arr=rpath.split("/");
    let arr = rpath ? rpath.split("/") : [];

    if (arr.length > 2) {
      str = "/" + arr[1] + "/" + arr[2];
    } else {
      str = "/" + arr[1];
    }

    config.headers["X-Guid"] = guidFn();
    config.headers["X-Path"] = str;
    return config;
  },
  function(err) {}
);
axios.interceptors.response.use(
  function(res) {

    if (res.data.code == "302") {
      sessionStorage.removeItem("ms_token");
      window.location.href = window.location.origin + "/#/login";
      return;
    }
    if (res.request.responseURL.indexOf("/security/web/auth/login") != -1) {
      sessionStorage.setItem("ms_token", res.headers["ms-token"]);
    }
    if (res.data.success) {
      sessionStorage.removeItem("specialPath");
      return res;
    }else if(res.headers['content-disposition']) {
      //表示下载文件
      return res;
    }else {

      let m = new vue();
      if (res.data.code == 10000) {
        m.$message.error(res.data.msg);
      } else {
        if (res.data.msg.indexOf("在系统内已存在") > -1) {
          return res;
        } else if (
          res.request.responseURL.indexOf("/emp/hrmsemployee/employeeInfo") > -1
        ) {
          return res;
        } else if (res.data.msg.indexOf("职级分类ID不允许为空") > -1) {
          return res;
        } else {
          m.$alert(res.data.msg, "提示");
          return res;
        }
      }
    }
    return res;
  },
  function(err) {
    if (err.response.status && err.response.status == 401) {
      window.location.href = err.response.headers.redirecturl;
    }
    // console.log(err);
    // return err;
    return Promise.reject(err);
  }
);

let request = {
  post: function(url, params) {
    return axios
      .post(url, params, {
        headers: {},
        timeout: 0,
        withCredentials: true
      })
      .then(res => {
        var p = new Promise((resolve, reject) => {
          resolve(res);
        });
        return p;
      })
      .catch(err => {});
  },

  get: function(url, params) {
    let t = new Date().getTime();
    let n = url.indexOf("?");
    if (n == "-1") {
      url = url + "?" + t;
    } else {
      url = url + "&" + t;
    }
    url = encodeURI(url);
    return axios({
      url: url,
      params: params,
      method: "get",
      withCredentials: true,
      timeout: 30000
    })
      .then(res => {
        var p = new Promise((resolve, reject) => {
          resolve(res);
        });
        return p;
      })
      .catch(err => {});
  },
  delete: function(url, params) {
    return axios({
      url: url,
      method: "delete",
      baseURL: "",
      data: params,
      withCredentials: true,
      headers: {},
      timeout: 30000
    })
      .then(res => {
        var p = new Promise((resolve, reject) => {
          resolve(res);
        });
        return p;
      })
      .catch(err => {});
  },
  put: function(url, params) {
    return axios
      .put(url, params, {
        headers: {},
        timeout: 30000,
        withCredentials: true
      })
      .then(res => {
        var p = new Promise((resolve, reject) => {
          resolve(res);
        });
        return p;
      })
      .catch(err => {});
  }
};
export default request;



// WEBPACK FOOTER //
// ./src/utils/request.config.js